import React from 'react';
import constants from "../../../../state/constants";
import styles from './index.module.scss';

const Images = (props) => {
    const imgs = (typeof props.items === 'undefined')? [] : props.items;

    return (
        <div className={styles.items}>
            {imgs['940x940'][0].map((value, key) => (
                <div key={value} className={`${key === 0 ? styles.items_item_full:styles.items_item_half}`}>
                    <picture>
                        <source
                            srcSet={constants.MAIN_URL + imgs['940x940'][1][key]}
                            type="image/webp"/>
                        <source
                            srcSet={constants.MAIN_URL + imgs['940x940'][0][key]}
                            type="image/jpeg"/>
                        <img loading="lazy" alt=""
                             src="/200-200product_empty.jpg"/>
                    </picture>
                  </div>
            ))}
        </div>
    );
}

export default Images